import { useMemo } from "react"
import { Table } from "antd"
import type { ColumnsType } from "antd/es/table"
import type { Key } from "react"
import { TrainingProject, TrainingProjectTableProps } from "../types"
import { TableActionColumn } from "@/components/TableActionColumn"
import { ID } from "@/types/common"

const TrainingProjectTable = ({
  trainingProjects,
  onEdit,
  onDelete,
  loading = false,
  selectedIds = [],
  onSelectionChange,
}: TrainingProjectTableProps) => {
  const columns: ColumnsType<TrainingProject> = useMemo(() => [
    {
      title: "项目名称",
      dataIndex: "name",
      key: "name",
      width: 200,
      ellipsis: true,
      sorter: (a: TrainingProject, b: TrainingProject) =>
        a.name.localeCompare(b.name, "zh"),
    },
    {
      title: "备注",
      dataIndex: "note",
      key: "note",
      ellipsis: true,
      render: (note: string) => note || "-",
    },
    TableActionColumn<TrainingProject>({
      onEdit,
      onDelete,
      deleteConfirmDescription: "确定要删除这个训练项目吗？",
      width: 150,
    }) as any,
  ], [onEdit, onDelete])

  const rowSelection = onSelectionChange
    ? {
        selectedRowKeys: selectedIds,
        onChange: (selectedRowKeys: Key[]) => {
          onSelectionChange(selectedRowKeys as ID[])
        },
        getCheckboxProps: (record: TrainingProject) => ({
          name: record.name,
        }),
      }
    : undefined

  return (
    <Table
      columns={columns}
      dataSource={trainingProjects}
      rowKey="id"
      loading={loading}
      rowSelection={rowSelection}
      pagination={{
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: (total, range) =>
          `第 ${range[0]}-${range[1]} 条，共 ${total} 条`,
        pageSizeOptions: ["10", "20", "50", "100"],
      }}
      size="middle"
      showSorterTooltip={false}
    />
  )
}

export default TrainingProjectTable
